import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Hero() {
  const scrollToCTA = () => {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-screen bg-dark-gray overflow-hidden" data-id="element-120">
      {/* Hero Image Background */}
      <div className="absolute inset-0 z-0" data-id="element-121">
        <img src="https://cdn.magicpatterns.com/uploads/7VRRVVFi6K52Rg3MFy8Krn/openrouter-generated-image-1771917792536.jpg" alt="Contratista en obra de construcción" className="w-full h-full object-cover opacity-40" data-id="element-122" />
        <div className="absolute inset-0 bg-gradient-to-b from-dark-gray/80 via-dark-gray/70 to-dark-gray" data-id="element-123"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 py-16 md:py-24 flex flex-col justify-center min-h-screen" data-id="element-124">
        {/* Logo/Badge */}
        <div className="flex items-center justify-center mb-8" data-id="element-125">
          <div className="bg-safety-yellow p-4 rounded-lg" data-id="element-126">
            <ShieldIcon className="w-12 h-12 text-dark-gray" aria-hidden="true" data-id="element-127" />
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white text-center mb-6 leading-tight" data-id="element-128">
          ¿Calendario vacío para el próximo mes?
          <span className="block text-safety-yellow mt-2" data-id="element-129">
            Llénalo en 21 días o menos.
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-300 text-center mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-130">
          El plan de rescate para contratistas hispanos que necesitan contratos{' '}
          <span className="text-safety-yellow font-semibold" data-id="element-131">ahora</span>, no
          promesas.
        </p>

        {/* Primary CTA */}
        <div className="flex flex-col items-center gap-4" data-id="element-132">
          <button onClick={scrollToCTA} className="cta-pulse bg-safety-yellow hover:bg-yellow-500 text-dark-gray font-bold text-xl md:text-2xl px-12 py-5 rounded-lg transition-all duration-300 transform hover:scale-105 min-h-[60px] w-full md:w-auto" aria-label="Obtener Blindaje 21" data-id="element-133">
            OBTENER BLINDAJE 21
          </button>
          <p className="text-gray-400 text-sm" data-id="element-134">
            Acceso instantáneo al PDF + Plan de Acción de 21 Días
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-gray-400 text-sm" data-id="element-135">
          <div className="flex items-center gap-2" data-id="element-136">
            <ShieldIcon className="w-5 h-5 text-safety-yellow" aria-hidden="true" data-id="element-137" />
            <span data-id="element-138">Garantía de devolución</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-139">
            <ShieldIcon className="w-5 h-5 text-safety-yellow" aria-hidden="true" data-id="element-140" />
            <span data-id="element-141">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-142">
            <ShieldIcon className="w-5 h-5 text-safety-yellow" aria-hidden="true" data-id="element-143" />
            <span data-id="element-144">Sin suscripciones</span>
          </div>
        </div>
      </div>
    </section>;
}